import React from "react";
import { Grid, Row, Col } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";
import Restricted from "./Restricted";

const Submenu = () => (
  <nav className="navbar navbar-default navbar-inverse">
    <Grid>
      <Row>
        <Col md={12}>
          <ul className="nav navbar-nav">
            <LinkContainer exact to={`/campaigns`}>
              <li>
                <a>Campanhas</a>
              </li>
            </LinkContainer>
            <Restricted accepted={["itau", "overmedia", "admin"]}>
              <LinkContainer exact to={`/campaigns/reports`}>
                <li>
                  <a>Relatório</a>
                </li>
              </LinkContainer>
            </Restricted>
          </ul>
        </Col>
      </Row>
    </Grid>
  </nav>
);

export default Submenu;



// WEBPACK FOOTER //
// ./src/components/Submenu.js